import { render, staticRenderFns } from "./DiscountRateEditWidget.vue?vue&type=template&id=5fd3a23b&"
import script from "./DiscountRateEditWidget.vue?vue&type=script&lang=js&"
export * from "./DiscountRateEditWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports